import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexLegend,
  ApexStroke,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive,
  ApexFill,
  ApexMarkers,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { MaterialModule } from '@app/material.module';

export interface MonthlyChart {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  fill: ApexFill;
  responsive: ApexResponsive[];
  markers: ApexMarkers;
  colors: string[];
}

@Component({
  selector: 'app-monthly-earnings',
  imports: [NgApexchartsModule, MaterialModule],
  templateUrl: './monthly-earnings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMonthlyEarningsComponent {
  @ViewChild('chart') chart: ChartComponent | null = null;
  readonly monthlyChart: MonthlyChart = this.initializeChart();

  constructor() {}

  private initializeChart(): MonthlyChart {
    return {
      chart: {
        id: 'sparkline3',
        type: 'area',
        height: 60,
        sparkline: {
          enabled: true,
        },
        group: 'sparklines',
        fontFamily: 'inherit',
        foreColor: '#adb0bb',
        animations: {
          enabled: true,
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
      },
      series: [
        {
          name: 'Earnings',
          color: 'var(--mat-sys-secondary)',
          data: [25, 66, 20, 40, 12, 58, 20],
        },
      ],
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 0,
          inverseColors: false,
          opacityFrom: 0.25,
          opacityTo: 0.05,
          stops: [20, 180],
        },
        opacity: 0.5,
      },
      markers: {
        size: 0,
      },
      tooltip: {
        theme: 'dark',
        fixed: {
          enabled: true,
          position: 'right',
        },
        x: {
          show: false,
        },
        y: {
          formatter: (val: number) => `$${val}k`,
        },
      },
      colors: ['var(--mat-sys-secondary)'],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      responsive: [],
    };
  }
}
